<template>
  <div v-if="horse_data" class="page-horse-item container mb-5 pb-5" style="max-width: 800px;">

    <div class="pt-5">
      <div class="row ">
        <div class="col-md-2">
          <span
            class="cp float-left op4"
            @click="historyBack()"
            >
            <i class="fas fa-arrow-left"></i>
            {{lg('',{
              en: 'Back',
              zh: '',
            })}}
          </span>
        </div>
        <div class="col-md-8 text-center">
          <h3 class="op4 b">
            {{horse_data.horse_name}}
          </h3>
          <div v-if="horse_data.is_in_stud" class="ml-auto">
            <span
              class="ui-tag-in-stud"
              >
              {{lg('',{
                en: 'IN STUD',
                zh: '',
              })}}
            </span>
          </div>
        </div>
        <div class="col-md-2"></div>
      </div>
    </div>
    
    <div class="text-center py-5">
      <div class="big-hores-avatar d-inline-block" style="width: 600px; height: 500px;">
        <picColored
          :img="data.image_url ||'/static/img/lion_full.png'"
          :color_xx="horse_data.horse_color"
        />
      </div>
    </div>

    <div class="my-5">
      <horseItemBlockSelectMate
        :data="horse_data"
      />
    </div>

    <div 
      class="ui-card mt-5" 
      :class="{'pb-5': horse_data.parent_male.tokenID != undefined && horse_data.child_list.length}"
      style="box-shadow: 0 0 0 1px rgba(120,120,120,0.2) inset;background: #2A2E35;"
      >
      <div class="sp-top-num-info" style="padding: 40px 0px 30px 40px;">
        <horseItemNumBlock 
          :data="horse_data"
          :cfg_show_icon="false"
        />
      </div>

      <!-- parents -->
      <div
        v-if="horse_data.parent_male.tokenID  && horse_data.parent_female.tokenID" 
        class="px-4 pt-4">
        <p class="op4">
          <small>
            {{lg('',{
              en: 'PARENTS',
              zh: '',
            })}}
          </small>
        </p>
        <div>
          <div class="row mx-4">
            <div class="col-md-6">
              <router-link
                class="ui-card"
                :to="{
                  name: 'horse_item',
                  params: {
                    id: horse_data.parent_male.tokenID
                  },
                }"
                >
                <horseItemCardSmall 
                  :data="horse_data.parent_male"
                />
                <div class="text-center small">
                  <span class="sp-gender-tag">
                    <span class="op5">SIRE</span>
                  </span>
                </div>
              </router-link>
            </div>
            <div class="col-md-6">
              <router-link
                class="ui-card"
                :to="{
                  name: 'horse_item',
                  params: {
                    id: horse_data.parent_female.tokenID
                  },
                }"
                >
                <horseItemCardSmall 
                  :data="horse_data.parent_female"
                />
                <div class="text-center small">
                  <span class="sp-gender-tag">
                    <span class="op5">DAM</span>
                  </span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <!-- child -->
      <div
        v-if="horse_data.child_list.length" 
        class="px-4 pt-4">
        <p class="op4">
          <small>
            {{lg('',{
              en: 'OFFSPRINGS',
              zh: '',
            })}}
          </small>
        </p>
        <div>
          <div class="row mx-4">
            <div 
              class="col-md-6"
              v-for="(item,index) of horse_data.child_list"
              :key="index"
              >
              <router-link
                class="ui-card"
                v-if="item.tokenID"
                :to="{
                  name: 'hores_item',
                  params: {
                    id: item.tokenID
                  },
                }"
                >
                <horseItemCardSmall 
                  :data="item"
                />
              </router-link>
            </div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
import picColored from '@/views/_cp_base/pic_colored.vue'
import horseItemNumBlock from '@/views/_cp_busi/horse_item_num_block.vue'
import horseItemCardSmall from '@/views/_cp_busi/horse_item_card_small.vue'
import horseItemBlockSelectMate from '@/views/_cp_busi//horse_item_block_select_mate.vue'

export default {
  name: 'horseDetail',
  components: {
    horseItemNumBlock,
    horseItemCardSmall,
    picColored,
    horseItemBlockSelectMate,
  },
  props: [],
  data() {
    return {
      horse_data: null,
      status_loading_horse_data: false,
    }
  },
  computed: {},
  watch: {},
  methods: {
    ...mapActions([
      'getHorseInfo',
    ]),

    async getPageData(){
      let v = this

      v.status_loading_horse_data = true
      let res = await v.getHorseInfo({
        horseID: v.$route.params.id,
      })
      v.status_loading_horse_data = false

      res = v.transHorseData(res)
      v.horse_data = res
    },
  },
  created() {
    let v = this
    v.getPageData()
    return
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  @import '~@/assets/css/vars.scss';

  .page-horse-item{


    .big-hores-avatar{
      background: radial-gradient(rgba($c,0.3), transparent, transparent);
      img{
        max-width: 100%;
      }
    }
    .sp-top-num-info{
      border: 1px solid  $c;
      border-radius: 20px;
      box-shadow: 0 10px 30px rgba(0,0,0,0.2);
      background-color: rgba(0,0,0,0.15);
    }
    .sp-gender-tag{
      border: 1px solid $c;
      background-color: #282828;
      transform: translateY(-12px);
      border-radius: 4px;
      padding: 0px 6px;
      height: 25px;
      line-height: 25px;
      display: inline-block;
      font-size: 12px;
    }
  }
</style>